module.exports = __webpack_public_path__ + "media/audio1.bd05844e.mp3";